/**
 * Chave da estação do WES Identity.
 *
 * A chave é por máquina, não por build nem por usuário: ela diz ao backend em
 * qual computador o médico está. Chega uma vez por parâmetro de URL
 * (`?station_key=...`), fica no localStorage e sai da barra de endereço.
 *
 * Módulo separado de `identityService` porque o `apiClient` a lê em toda
 * requisição de identidade, e o `identityService` depende do `apiClient`.
 */

export const STATION_KEY_STORAGE = 'hub360_station_key';
const STATION_KEY_PARAM = 'station_key';

export function readStationKey() {
  try {
    return window.localStorage.getItem(STATION_KEY_STORAGE) || null;
  } catch {
    return null;
  }
}

/**
 * Consome `?station_key=` da URL atual, grava e apaga da barra de endereço.
 *
 * Apagar não é estética: a chave na URL iria para o histórico do navegador,
 * para favoritos e para o `Referer` da próxima requisição externa.
 */
export function captureStationKeyFromUrl() {
  if (typeof window === 'undefined') return false;
  const url = new URL(window.location.href);
  const key = url.searchParams.get(STATION_KEY_PARAM);
  if (!key) return false;

  url.searchParams.delete(STATION_KEY_PARAM);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);

  try {
    window.localStorage.setItem(STATION_KEY_STORAGE, key);
    return true;
  } catch {
    return false;
  }
}
